/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o="OBJECTID";export{o as fallbackObjectIDAttribute};
